import { render, staticRenderFns } from "./MasterBagsTab.vue?vue&type=template&id=3563674e"
import script from "./MasterBagsTab.vue?vue&type=script&lang=js"
export * from "./MasterBagsTab.vue?vue&type=script&lang=js"
import style0 from "./MasterBagsTab.vue?vue&type=style&index=0&id=3563674e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports